import React from 'react'
import {AddCardLink} from '../styles/Base'

export default ({onClick, t}) => <AddCardLink onClick={onClick}>{t('Click to add card')}</AddCardLink>
